import { SCORE_GAUGE_TOTAL, SCORE_GAUGE_OFFSET } from "./constants";

const SCORE_PILLS = [
  { label: "Technicals", value: 82 },
  { label: "Fundamentals", value: 71 },
  { label: "Momentum", value: 78 },
  { label: "Valuation", value: 65 },
  { label: "Risk", value: 77 },
  { label: "Structure", value: 73 },
];

export const KiraScoreSection = () => (
  <section id="kira-score" className="score-section" data-testid="score-section">
    <div className="score-inner reveal">
      <div className="score-badge">Coming Soon</div>
      <h2 className="score-title">
        Every Stock.<br />
        <span className="gold">One KIRA Score.</span>
      </h2>
      <p className="score-sub">
        KIRA Score is our proprietary research framework combining technical analysis,
        fundamentals, momentum, valuation, risk assessment and market structure into
        one simple institutional score.
      </p>
      <div className="score-preview">
        <div className="score-preview-ring">
          <svg viewBox="0 0 120 120" width="140" height="140" aria-hidden="true">
            <circle cx="60" cy="60" r="52" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="10" />
            <circle
              cx="60" cy="60" r="52" fill="none"
              stroke="url(#scoreGrad)" strokeWidth="10" strokeLinecap="round"
              strokeDasharray={SCORE_GAUGE_TOTAL} strokeDashoffset={SCORE_GAUGE_OFFSET}
              transform="rotate(-90 60 60)"
            />
            <defs>
              <linearGradient id="scoreGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#D4AF37" />
                <stop offset="100%" stopColor="#F2C94C" />
              </linearGradient>
            </defs>
          </svg>
          <div className="score-preview-num">
            <span className="gold">75</span>
            <small>/100</small>
          </div>
        </div>
        <div className="score-pills">
          {SCORE_PILLS.map((p) => (
            <div className="score-pill" key={p.label}><span>{p.label}</span><strong>{p.value}</strong></div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
